/**
 * Cause labels, shared by the screen and the workbook export.
 *
 * A module of their own rather than living in the component: the export needs them too, and
 * importing them from the component would form a cycle the moment the component imports the
 * export back.
 */
/** Machine cause -> what an accountant would call it.
 *
 *  The API returns the raw category (`bills_never_received`). Causes are invented during
 *  investigation - two of them appeared mid-way through band D - so this map is deliberately
 *  PARTIAL and falls back to de-snake-casing the raw value. A missing entry must degrade to a
 *  readable label, never to a blank cell. */
export const CAUSE_LABEL: Record<string, string> = {
	none: 'Not yet investigated',
	bills_never_received: 'Bills never received',
	bills_never_booked: 'Bills never booked',
	bills_never_booked_despite_internal_escalation: 'Never booked — Finance had flagged it',
	filed_not_booked: 'Filed by vendor, not booked',
	vendor_reversed_in_2b: 'Vendor reversed it in 2B',
	vendor_partly_reversed_in_2b: 'Vendor partly reversed it in 2B',
	suspected_vendor_2b_value_typo: "Suspected typo in vendor's 2B value",
	disputed_service_never_booked: 'Disputed service, never booked',
	vendor_has_two_gstins: 'Vendor has two GSTINs',
	booked_as_expense_not_bill: 'Booked as an expense, not a bill',
	reimbursed_not_a_bill: 'Reimbursed — not a vendor bill',
	retail_purchases_partly_booked: 'Retail purchases, partly booked',
	matcher_bundle_only_credits_first_number: 'Already booked — bundled bill (our bug)',
	duplicate_2b_filing: 'Vendor filed it twice',
	zoho_vendor_wrong_gstin: 'Wrong GSTIN on the Zoho vendor',
	marketplace_seller_not_a_vendor: 'Marketplace seller, not our vendor',
	return_filed_as_2b_invoice: 'A return filed as a 2B invoice',
	gstin_typo: 'GSTIN typo',
	gstin_unknown: 'GSTIN unknown',
};
export const causeLabel = (c: string) => CAUSE_LABEL[c] ?? c.replace(/_/g, ' ').replace(/^./, m => m.toUpperCase());
